export default __webpack_public_path__ + "2851de3ad8226bdc4cae82364779bffa.png";